var _defs, _path, _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoheartinactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_heart_inactive",
    "data-name": "ico heart inactive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.406,
    height: 24.438,
    viewBox: "0 0 24.406 24.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .inactiveHeart{\r\n        fill: #aabfd0 !important;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "inactiveHeart",
    d: "M827.8,140a12.216,12.216,0,1,1-12.2,12.216A12.206,12.206,0,0,1,827.8,140Z",
    transform: "translate(-815.594 -140)"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "heart",
    x: 5.406,
    y: 7,
    width: 13,
    height: 12,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAzklEQVQokXWQMWpCQRRFj9r9VNb5W7AKZAUpLCwCAQk2WVGqbESwkRSpgwpZQJqQgEVsrQJ6wtP5YfIdLwwz3HfPmzfTUUm6BoZAGHNgCVwBN0APeAZWh2hA6pNHvauf6fya9o/Mezxcot6rO3WcGjTeVp1k3kMC72K8GbADbvmvLrBvedPwotAHvjhVGwitIx/QAhgBF4VQrirl3mLWS/VbfVGr7A35qlJ9o9ZNYZCMEpgDkfv78nPgCdCG2mBdAkpQDv6UgHNQA85LgMovUd9tOvJlL7IAAAAASUVORK5CYII="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoheartinactive);
export default __webpack_public_path__ + "static/media/ico heart inactive.ed75bceb.svg";
export { ForwardRef as ReactComponent };